<template>
  <div class="team-manage-box">
    <div
      class="team-member-box"
      :class="expandedArrow ? '' : 'openTree'"
      v-show="isTeamMemberVisible">
      <div
        class="team-member-box-tree"
        v-show="expandedArrow">
        <div class="title-box">
          <div class="symbol" />
          <div class="name">团队管理员</div>
        </div>
        <div class="common-input-box">
          <el-input
            v-show="expandedArrow"
            class="input-primary"
            size="mini"
            v-model="userNameInput"
            placeholder="请输入用户名称"
            clearable
            @clear="updateOptionalUserList"
            @keyup.enter.native="updateOptionalUserList">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="updateOptionalUserList" />
          </el-input>
        </div>
        <div class="member-data-box">
          <div v-if="isMemberListloading">
            <Spin
              :pointNum="8"
              :translateX="25"
              background="var(--base-primary-bgColor)" />
          </div>
          <div
            class="member-list-box"
            v-if="!isMemberListloading && optionalUserList.length">
            <div
              v-for="(item, index) in optionalUserList"
              :key="index"
              :class="`list-item-box ${isMemberActive(item) ? 'active' : ''}`"
              @click="handleOptionalUserClick(item)">
              <div class="user-info-box">
                <div
                  class="text-overflow"
                  :title="item.userName">
                  {{ item.userName }}
                </div>
                <div
                  class="curr-user-box"
                  v-if="isCurrUser(item)">
                  当前用户
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!isMemberListloading && !optionalUserList.length"
            class="common-empty-box">
            <bj-empty
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template>
                <div class="text-box empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </div>
      </div>
      <div
        class="expaned"
        @click="() => (expandedArrow = !expandedArrow)">
        <i
          v-if="!expandedArrow"
          size="14"
          class="el-icon-arrow-right el-icon"></i>
        <i
          v-else
          size="14"
          class="el-icon-arrow-left el-icon"></i>
      </div>
    </div>
    <div
      class="sub-user-box outer-page-primary"
      :style="{ width: expandedArrow ? 'calc(100% - 276px)' : '100%' }">
      <div class="header-box">
        <div class="title-box">
          <div class="symbol" />
          <div class="title">团队成员</div>
        </div>
      </div>
      <div class="operation-box">
        <div class="common-button-box btn-group-primary">
          <el-button
            class="primary-btn gr8"
            v-if="isChecked('TeamManage.Add')"
            type="primary"
            size="small"
            @click="openUserRelationDialog">
            添加成员
          </el-button>
          <el-button
            class="normal-btn"
            v-if="isChecked('TeamManage.BatchDelete')"
            size="small"
            @click="batchRelieveRelation">
            批量移除成员
          </el-button>
        </div>
        <div class="filter-box">
          <div class="filter-item-box">
            <div class="label-box searchLabel">用户名：</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                placeholder="请输入用户名称"
                v-model="userName" />
            </div>
          </div>
          <div class="filter-item-box">
            <div class="label-box searchLabel">手机号：</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="small"
                placeholder="请输入手机号"
                v-model="phone" />
            </div>
          </div>
          <div class="common-button-box btn-group-primary">
            <el-button
              size="small"
              class="primary-btn gr8"
              type="primary"
              @click="searchSubUser">
              查询
            </el-button>
            <el-button
              size="small"
              class="normal-btn"
              @click="resetFilter"
              >重置</el-button
            >
          </div>
        </div>
      </div>
      <div class="sub-user-list-box">
        <div class="common-table-box">
          <el-table
            ref="table"
            :data="subUserList"
            height="100%"
            class="publish-table"
            highlight-selection-row
            @select="selectChange"
            @select-all="selectChange">
            <el-table-column
              type="selection"
              width="60" />
            <el-table-column
              label="序号"
              type="index"
              width="55" />
            <el-table-column
              label="用户名"
              prop="userName">
              <template v-slot="{ row }">
                <div
                  class="text-overflow"
                  :title="row.userName">
                  {{ row.userName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="手机号"
              prop="phoneNumber" />
            <el-table-column label="邮箱">
              <template #default="{ row }">
                {{ row?.email || '--' }}
              </template>
            </el-table-column>
            <el-table-column
              label="姓名"
              prop="name" />
            <el-table-column label="公司">
              <template #default="{ row }">
                {{ row?.company || '--' }}
              </template>
            </el-table-column>
            <el-table-column label="企业类型">
              <template #default="{ row }">
                {{ row?.enterpriseType || '--' }}
              </template>
            </el-table-column>
            <el-table-column label="职位">
              <template #default="{ row }">
                {{ row?.position || '--' }}
              </template>
            </el-table-column>
            <el-table-column
              label="角色"
              prop="roleName" />
            <el-table-column
              label="操作"
              width="120">
              <template v-slot="{ row }">
                <div class="common-button-box operation-cell">
                  <el-button
                    v-if="isChecked('TeamManage.Delete')"
                    @click="relieveRelation(row)"
                    type="text"
                    size="small">
                    移除成员
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="common-empty-box">
                <bj-empty
                  :image="require('@/assets/img/no-data.png')"
                  class="empty-page">
                  <template>没有找到相关内容</template>
                </bj-empty>
              </div>
            </template>
          </el-table>
        </div>
        <div class="common-pagination-box">
          <el-pagination
            class="pagination-primary"
            popper-class="common-pagination-popper-box"
            layout="sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100, 150, 200]"
            :page-size="pageSize"
            :current-page="currPage"
            :total="total"
            @size-change="sizeChange"
            @current-change="pageChange" />
        </div>
      </div>
    </div>
    <UserRelationDialog
      v-if="isUserRelationDialogVisible"
      :visible="isUserRelationDialogVisible"
      :userList="unBindUserList"
      :search="searchUnBindUserList"
      :submitRequest="createUserRelation"
      :closeDialog="closeUserRelationDialog" />
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'
import UserRelationDialog from '@/components/UserRelationDialog.vue'

import { Store } from '@/utils/store'

import {
  getOptionalUserListService,
  getUserRelationListService,
  getUnBindUserListService,
  createUserRelationService,
  delUserRelationCheckService,
  deleteUserRelationService,
  batchDeleteUserRelationService
} from '@/service/interface'

export default {
  data() {
    return {
      isTeamMemberVisible: true,
      isMemberListloading: false,
      userNameInput: '',
      optionalUserList: [],
      selectUserInfo: {},
      expandedArrow: true,
      userName: '',
      phone: '',
      currPage: 1,
      pageSize: 10,
      total: 0,
      subUserList: [],
      selectMembers: [],

      isUserRelationDialogVisible: false,
      unBindUserList: []
    }
  },
  components: {
    Spin,
    UserRelationDialog
  },
  mounted() {
    this.initOptionalUserList()
  },
  methods: {
    initOptionalUserList() {
      this.isMemberListloading = true
      this.queryOptionalUserList().then(optionalUserList => {
        this.optionalUserList = optionalUserList
        if (optionalUserList.length) {
          let defaultUserInfo = optionalUserList[0]
          this.currPage = 1
          this.handleOptionalUserClick(defaultUserInfo)
        }

        this.isMemberListloading = false

        this.isTeamMemberVisible = this.isMemberVisible()
      })
    },
    updateOptionalUserList() {
      return new Promise(resolve => {
        this.isMemberListloading = true
        this.queryOptionalUserList().then(optionalUserList => {
          this.optionalUserList = optionalUserList

          this.isMemberListloading = false
          resolve()
        })
      })
    },
    handleOptionalUserClick(userInfo) {
      this.selectUserInfo = userInfo
      this.currPage = 1
      this.queryUserRelationList().then(subUserList => {
        this.subUserList = subUserList
      })
    },
    updateSubUserList() {
      return new Promise(resolve => {
        this.queryUserRelationList().then(subUserList => {
          this.subUserList = subUserList
          resolve()
        })
      })
    },
    searchSubUser() {
      this.queryUserRelationList().then(subUserList => {
        this.subUserList = subUserList
      })
    },
    resetFilter() {
      this.userName = ''
      this.phone = ''
    },
    openUserRelationDialog() {
      this.queryUnBindUserListList().then(unBindUserList => {
        if (!unBindUserList.length) {
          this.$message.warning('该用户没有可以添加的成员！')
        } else {
          this.unBindUserList = unBindUserList

          this.isUserRelationDialogVisible = true
        }
      })
    },
    searchUnBindUserList(userName, phone) {
      this.queryUnBindUserListList(userName, phone).then(unBindUserList => {
        this.unBindUserList = unBindUserList
      })
    },
    createUserRelation(userIds) {
      return new Promise(resolve => {
        let parentUserId = ''
        if (Object.keys(this.selectUserInfo).length) {
          parentUserId = this.selectUserInfo.userId
        } else {
          let userInfo = Store.userInfo
          parentUserId = userInfo.userId
        }

        let params = { parentUserId, userIds }
        createUserRelationService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              this.updateOptionalUserList().then(() => {
                this.updateSubUserList().then(() => {
                  this.$message.success('添加用户关系成功')
                  resolve()
                })
              })
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    closeUserRelationDialog() {
      this.$nextTick(() => {
        this.isUserRelationDialogVisible = false
      })
    },
    delUserRelationCheck(userIds) {
      return new Promise(resolve => {
        let params = { userIds }
        delUserRelationCheckService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              let errMsg = response.errMsg
              if (errMsg) {
                let checkResult = {
                  isCheckPass: true,
                  isJumpDialog: true
                }
                this.$confirm(errMsg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                })
                  .then(() => {
                    resolve(checkResult)
                  })
                  .catch(() => {
                    this.$message.info('取消解除用户关系')
                  })
              } else {
                let checkResult = {
                  isCheckPass: true,
                  isJumpDialog: false
                }
                resolve(checkResult)
              }
            } else {
              this.$confirm(response.errMsg, '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                let checkResult = {
                  isCheckPass: false,
                  isJumpDialog: false
                }
                resolve(checkResult)
              })
            }
          }
        })
      })
    },
    relieveRelation(userInfo) {
      let userIds = [userInfo.userId]
      this.delUserRelationCheck(userIds).then(result => {
        if (result.isCheckPass) {
          this.$confirm('确定解除用户关系？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              let userIds = [userInfo.userId]
              this.deleteUserRelation(userIds).then(() => {
                this.updateOptionalUserList().then(() => {
                  this.updateSubUserList().then(() => {
                    this.$message.success('解除用户关系成功')
                  })
                })
              })
            })
            .catch(() => {
              this.$message.info('取消解除用户关系')
            })
        }
      })
    },
    batchRelieveRelation() {
      if (!this.selectMembers.length) {
        this.$message.warning('请选择需要移除的团队成员')
        return
      }

      let userIds = this.selectMembers.map(el => el.userId)
      this.delUserRelationCheck(userIds).then(result => {
        if (result.isCheckPass) {
          if (result.isJumpDialog) {
            this.deleteUserRelation(userIds).then(() => {
              this.updateOptionalUserList().then(() => {
                this.updateSubUserList().then(() => {
                  this.$message.success('解除用户关系成功')
                })
              })
            })
          } else {
            this.$confirm('是否解除用户关系？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                this.deleteUserRelation(userIds).then(() => {
                  this.updateOptionalUserList().then(() => {
                    this.updateSubUserList().then(() => {
                      this.$message.success('解除用户关系成功')
                    })
                  })
                })
              })
              .catch(() => {
                this.$message.info('取消解除用户关系')
              })
          }
        }
      })
    },
    deleteUserRelation(userIds) {
      return new Promise(resolve => {
        if (userIds.length === 1) {
          deleteUserRelationService(userIds[0]).then(result => {
            if (result.status === 200) {
              let response = result.data
              if (response.isSuccess) {
                resolve()
              } else {
                this.$message.error(response.errMsg)
              }
            }
          })
        } else {
          let params = { userIds }
          batchDeleteUserRelationService(params).then(result => {
            if (result.status === 200) {
              let response = result.data
              if (response.isSuccess) {
                resolve()
              } else {
                this.$message.error(response.errMsg)
              }
            }
          })
        }
      })
    },
    pageChange(currPage) {
      this.currPage = currPage
      this.updateSubUserList()
    },
    sizeChange(pageSize) {
      this.pageSize = pageSize
      this.currPage = 1
      this.updateSubUserList()
    },
    selectChange(selectMembers) {
      this.selectMembers = selectMembers
    },
    queryOptionalUserList() {
      return new Promise(resolve => {
        let params = { userName: this.userNameInput }
        getOptionalUserListService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              let optionalUserList = response.data
              let currUserInfo = Store.userInfo
              optionalUserList = optionalUserList.filter(
                el => el.userId !== currUserInfo.userId
              )
              if (currUserInfo.surname.includes(this.userNameInput)) {
                let userInfo = {
                  userId: currUserInfo.userId,
                  userName: currUserInfo.surname
                }
                optionalUserList = [userInfo, ...optionalUserList]
              }
              resolve(optionalUserList)
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    queryUserRelationList() {
      return new Promise(resolve => {
        let parentUserId = ''
        if (Object.keys(this.selectUserInfo).length) {
          parentUserId = this.selectUserInfo.userId
        } else {
          let userInfo = Store.userInfo
          parentUserId = userInfo.userId
        }
        let params = {
          parentUserId,
          userName: this.userName,
          phone: this.phone,
          maxResultCount: this.pageSize,
          skipCount: (this.currPage - 1) * this.pageSize
        }
        getUserRelationListService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              let data = response.data
              let subUserList = data.items
              this.total = data.totalCount
              resolve(subUserList)
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    queryUnBindUserListList(userName, phone) {
      return new Promise(resolve => {
        let parentUserId = ''
        if (Object.keys(this.selectUserInfo).length) {
          parentUserId = this.selectUserInfo.userId
        } else {
          let userInfo = Store.userInfo
          parentUserId = userInfo.userId
        }
        let params = { parentUserId, userName, phone }
        getUnBindUserListService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              let unBindUserList = response.data
              unBindUserList = unBindUserList.map(item => {
                item.phone = item.phoneNumber
                return item
              })
              resolve(unBindUserList)
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    isMemberVisible() {
      let visible = false
      let userInfo = Store.userInfo
      if (!this.userNameInput) {
        let otherMembers = this.optionalUserList.filter(
          el => el.userId !== userInfo.userId
        )
        if (otherMembers.length) {
          visible = true
        }
      }

      return visible
    },
    isMemberActive(userInfo) {
      return this.selectUserInfo.userId === userInfo.userId
    },
    isCurrUser(userInfo) {
      let currUserInfo = Store.userInfo
      return currUserInfo.userId === userInfo.userId
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.team-manage-box {
  display: flex;
  // justify-content: space-between;
  width: 100%;
  height: 100%;
  text-align: left;

  .team-member-box-tree {
    height: 100%;
  }
  .team-member-box {
    // flex-shrink: 0;
    width: 260px;
    height: 100%;
    min-height: 320px;
    margin-right: 16px;
    padding: 16px;
    border-radius: 16px;
    background: var(--aside-page-bgColor);
    transition: all 0.3s;
    position: relative;

    &:hover {
      .expaned {
        display: block;
      }
    }

    .title-box {
      display: flex;
      align-items: center;

      .symbol {
        width: 4px;
        height: 20px;
        border-radius: 4px;
        background: var(--base-primary-bgColor);
      }

      .name {
        margin-left: 10px;
        color: var(--page-title-color);
      }
    }

    .common-input-box {
      margin: 16px 0px 16px 0;
    }

    .member-data-box {
      position: relative;
      height: calc(100% - 90px);

      .member-list-box {
        height: 100%;
        overflow-y: auto;

        .list-item-box {
          padding: 5px 20px;
          border-radius: 4px;
          cursor: pointer;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 400;
          color: var(--tree-node-text-color);
          &:not(:last-child) {
            margin-bottom: 4px;
          }
          &:hover {
            background: var(--tree-item-hover-color);
          }

          .user-info-box {
            display: flex;
            align-items: center;

            .curr-user-box {
              font-size: 12px;
              font-weight: 400;
              flex-shrink: 0;
              margin-left: 10px;
              padding: 0px 5px;
              line-height: 22px;
              height: 22px;
              border-radius: 6px;
              color: var(--base-primary-bgColor);
              border: 1px solid var(--base-primary-bgColor);
              background-color: var(--base-bg-light-color24);
              display: flex;
              align-items: center;
            }
          }
        }

        .active {
          color: var(--base-primary-bgColor) !important;
          background: var(--base-bg-light-color24) !important;
        }
      }

      .common-empty-box {
        .text-box {
          margin: auto;
          color: var(--normal-status-color);
          font-size: 14px;
        }
      }
    }
  }

  .sub-user-box {
    flex-grow: 1;
    width: calc(100% - 260px);
    height: 100%;
    transition: all 0.3s;
    .header-box {
      display: flex;
      justify-content: space-between;

      .title-box {
        display: flex;
        align-items: center;

        .symbol {
          width: 4px;
          height: 20px;
          border-radius: 4px;
          background: var(--base-primary-bgColor);
        }

        .title {
          margin-left: 10px;
          color: var(--page-title-color);
        }
      }
    }

    .operation-box {
      display: flex;
      justify-content: space-between;

      .filter-box {
        display: flex;

        .filter-item-box {
          display: flex;
          align-items: center;
          margin-left: 15px;
        }

        .common-button-box {
          .el-button {
            // margin-left: 15px;
          }
        }
      }
    }

    .sub-user-list-box {
      height: calc(100% - 104px);
      padding: 0 16px;

      .common-table-box {
        min-width: 850px;
        min-height: 300px;
        height: calc(100% - 65px);
      }

      .common-pagination-box {
        text-align: center;
      }
    }
  }
}
.expaned {
  width: 24px;
  height: 40px;
  border-radius: 16px;
  background-color: var(--aside-arrow-bgColor);
  box-shadow: var(--base-bg-dark-color30);
  border: 1px solid var(--aside-arrow-bgColor);
  position: absolute;
  top: 50%;
  left: 246px;
  transform: translateY(-50%);
  display: none;
  line-height: 40px;
  cursor: pointer;
  &:hover {
    background-color: var(--aside-arrow-hover-bgColor);
    box-shadow: var(--base-bg-dark-color30);
    border-color: transparent;
    border-radius: 16px;
  }

  .el-icon {
    font-weight: 600;
    color: var(--aside-arrow-expand-icon-color);
    margin-left: 50%;
    transform: translateX(-50%);
  }
}
.openTree {
  width: 0 !important;
  padding: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  border: none;
  .expaned {
    left: -12px !important;
    z-index: 9;
    display: block !important;
  }
}
</style>
